var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goBack",on:{"click":_vm.goBack}},[_vm._v("\n    <\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }